import sendPostCrm from './crm';

const forms = Array.from(document.querySelectorAll('.js-lander-form'));

forms.forEach((form) => {
    let callRequest = form.querySelector('[data-name="callRequest"]').value;
    const applicantPhoneInput = form.querySelector('[data-name="applicantPhone"]');
    const errorMessage = form.querySelector('.js-submit-error');
    const submitBtn = form.querySelector('[type="submit"]');

    const showErrorMessage = (message) => {
        if (message) errorMessage.innerHTML = message;
        errorMessage.classList.add('is-visible');
    };

    const disableSubmit = () => {
        submitBtn.setAttribute('disabled', true);
        submitBtn.innerHTML = 'Submitting...';
    };

    const enableSubmit = () => {
        submitBtn.setAttribute('disabled', false);
        submitBtn.innerHTML = 'Try for free';
    };

    form.querySelector('.js-phone-consultation').addEventListener('change', (event) => {
        if (event.target.checked) {
            callRequest = 'With consultation';
            applicantPhoneInput.classList.add('is-visible');
        } else {
            callRequest = 'Without consultation';
            applicantPhoneInput.classList.remove('is-visible');
        }
    });

    form.addEventListener('submit', (e) => {
        e.preventDefault();

        const applicantFirstName = form.querySelector('[data-name="applicantFirstName"]').value;
        const applicantLastName = form.querySelector('[data-name="applicantLastName"]').value;
        const applicantEmail = form.querySelector('[data-name="applicantEmail"]').value;
        const calculatorType = form.querySelector('[name=calculatorType]').value;
        const createUserUrl = form.action;

        window.localStorage.setItem('applicantName', applicantFirstName);

        let redirectUrl;
        let enquiryType;

        switch (true) {
        case (calculatorType === 'Investing Calculator'):
            redirectUrl = '/investing-welcome';
            enquiryType = 'investing lander';
            break;
        default:
            redirectUrl = '/welcome';
            enquiryType = 'savings';
            break;
        }

        const triggerTracking = () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'calculatorResults',
                calculatorType,
                callRequest,
            });

            window.fbq('track', 'Lead', {
                content_name: calculatorType === 'Investing Calculator' ? 'Investing' : 'Saving',
            });
        };

        const savings = Number(document.querySelector('[data-for=currentSaving]').value.replace(/,/gi, ''));
        const age = Number(document.querySelector('[data-for=currentAge]').value);

        const params = {
            enquiryType,
            savings,
            age,
            applicantFirstName,
            applicantLastName,
            applicantPhone: applicantPhoneInput.value,
            applicantEmail,
            createUserUrl,
            redirectUrl,
            showErrorMessage,
            disableSubmit,
            enableSubmit,
            triggerTracking,
        };

        sendPostCrm(params);
    });
});

const landerSuccess = document.querySelector('.js-lander-success');
if (landerSuccess) {
    const applicantName = window.localStorage.getItem('applicantName');
    const userId = window.localStorage.getItem('userId');
    document.querySelector('[data-for="applicantName"]').textContent = applicantName;
    const getStartedBtns = Array.from(document.querySelectorAll('.gtm-get-started'));
    getStartedBtns.forEach((btn) => {
        // eslint-disable-next-line no-param-reassign
        btn.href = `${btn.href}?uuid=${userId}`;
    });
}




// WEBPACK FOOTER //
// ./app/scripts/components/lander-form.js